var _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkpermit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.8,
    y: 102.13,
    width: 86.7,
    height: 115.95,
    transform: "translate(472.09 -197.26) rotate(84.75)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.9,
    y: 123.46,
    width: 102.52,
    height: 73.27,
    transform: "translate(-13.21 32.16) rotate(-5.25)",
    style: {
      fill: "#fafafa",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.9,132.43l.6,6.61-39.65,3.65,2,21.8L310,187.42l19.34-1.78,31.06-2.85,1.43-.14,21.5-2L383,177l-5.68.52a5.86,5.86,0,0,1,4.59-5.52l.62-.14-1.3-14.09-3.83.35-2.61-28.41Zm-33.64,53.42-1.85-20.06,4.44-.41a7.31,7.31,0,0,0,7.61,5.08l.72-.06-.53-5.74,4.24-.38,1.85,20.06Zm17.91-1.64-2-21.5-7.11.65.52,5.69a5.87,5.87,0,0,1-5.52-4.6l-.14-.61-5.67.52L307.41,144l38.22-3.51,2,21.8,3.26-.3,5.14-.47,2.35-.22,1.84,20.06Zm21.6-23.67-.4-4.33a5.86,5.86,0,0,1,5.3,3.88Zm29.11-1.23,1.05,11.43a7.3,7.3,0,0,0-5.07,7.61l.06.72,5.73-.53.07.84-20.06,1.84-1.84-20.06,17.66-1.63Zm-6.44-28.06,2.48,27-16.23,1.5-1.44.13-1.1.1a7.29,7.29,0,0,0-7.63-5.16l-.72.06.53,5.82-.39,0-2-21.8-.48-5.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.53,
    y: 90.61,
    width: 88.45,
    height: 118.28,
    transform: "translate(306.72 47.78) rotate(101.25)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.38,
    y: 97.46,
    width: 74.75,
    height: 104.58,
    transform: "translate(-39.21 251.72) rotate(-78.75)",
    style: {
      fill: "#fafafa",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,122.9l-1.32,6.64-39.85-7.92L97,143.52l-4.58,23,19.44,3.87,31.21,6.2,1.44.29,21.59,4.29.74-3.72-5.71-1.13a6,6,0,0,1,6.09-4.07l.65,0,2.81-14.15-3.84-.77,5.67-28.55ZM94.12,165.41l4-20.16,4.46.88a7.45,7.45,0,0,0,6,7.18l.72.14,1.15-5.76,4.26.85-4,20.16Zm18,3.58,4.29-21.6L109.27,146l-1.13,5.71a6,6,0,0,1-4.07-6.09l0-.65-5.7-1.13,4.08-20.47,38.4,7.64-4.36,21.91,3.28.65,5.16,1,2.36.46-4,20.16Zm28-16.89.86-4.36a6,6,0,0,1,4.06,5.34Zm28.83,7.23-2.28,11.48a7.45,7.45,0,0,0-7.17,6l-.15.72,5.76,1.15-.17.84-20.16-4,4-20.16,17.75,3.53ZM170.76,130l-5.39,27.11-16.31-3.25-1.44-.28-1.11-.22a7.43,7.43,0,0,0-6-7.26l-.72-.15-1.16,5.84-.4-.08,4.36-21.9,1-5.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.12,107h-9.78a10.29,10.29,0,0,1-10.29-10.29V87a10.29,10.29,0,0,1,10.29-10.29h9.78A10.3,10.3,0,0,1,309.41,87v9.78A10.3,10.3,0,0,1,299.12,107Zm-9.78-27.36A7.3,7.3,0,0,0,282.05,87v9.78a7.3,7.3,0,0,0,7.29,7.29h9.78a7.3,7.3,0,0,0,7.29-7.29V87a7.3,7.3,0,0,0-7.29-7.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.16 98.2 275.9 83.94 280.15 79.7 290.16 89.72 308.31 71.57 312.55 75.81 290.16 98.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.16,238H81.63A7.94,7.94,0,0,1,73.69,230V222.5a7.94,7.94,0,0,1,7.94-7.93h7.53a7.94,7.94,0,0,1,7.93,7.93V230A7.94,7.94,0,0,1,89.16,238Zm-7.53-21.09A5.63,5.63,0,0,0,76,222.5V230a5.63,5.63,0,0,0,5.63,5.62h7.53A5.62,5.62,0,0,0,94.78,230V222.5a5.62,5.62,0,0,0-5.62-5.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.26 231.16 71.27 220.18 74.54 216.91 82.26 224.63 96.24 210.64 99.51 213.91 82.26 231.16",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,299.33h-7.54a7.94,7.94,0,0,1-7.93-7.93v-7.54a7.94,7.94,0,0,1,7.93-7.93H431a7.94,7.94,0,0,1,7.93,7.93v7.54A7.94,7.94,0,0,1,431,299.33Zm-7.54-21.09a5.62,5.62,0,0,0-5.62,5.62v7.54a5.62,5.62,0,0,0,5.62,5.62H431a5.62,5.62,0,0,0,5.62-5.62v-7.54a5.62,5.62,0,0,0-5.62-5.62Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.1 292.52 413.11 281.54 416.38 278.27 424.1 285.99 438.08 272 441.35 275.27 424.1 292.52",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-64",
    cx: 250,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.44,200a75.77,75.77,0,0,1,5.17-11c.95-1.74,2-3.42,3-5.09s2.1-3.29,3.3-5a4.92,4.92,0,0,1,8.1,5.58l0,.06c-1,1.46-2,3-3,4.6s-1.91,3.14-2.84,4.72a83.28,83.28,0,0,0-4.88,9.52c-.4,1-.75,1.94-1,2.85H345.8A33.68,33.68,0,0,1,347.44,200Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.83,168.43c-9.56,2.12-17.65,22.73-17.65,22.73l11,6.25a46.47,46.47,0,0,0,8-11.78C370.58,180.51,375.35,166.54,366.83,168.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.34,180a45.65,45.65,0,0,1-2.16,5.62,46.47,46.47,0,0,1-8,11.78L357.79,196c3.79-6.88,3.75-15.67,3.75-15.67l8.24-1.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,242.06H357a1.67,1.67,0,0,1,1.67,1.67V264a1.67,1.67,0,0,1-1.67,1.67h-.09a2.78,2.78,0,0,1-2.78-2.78V244.35A2.29,2.29,0,0,1,356.4,242.06Z",
    transform: "translate(49.03 -57.56) rotate(9.91)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.4,242.06H357a1.67,1.67,0,0,1,1.67,1.67V264a1.67,1.67,0,0,1-1.67,1.67h-.09a2.78,2.78,0,0,1-2.78-2.78V244.35A2.29,2.29,0,0,1,356.4,242.06Z",
    transform: "translate(49.03 -57.56) rotate(9.91)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.3 405.33 351.84 405.24 351.22 387.9 361.07 388.06 359.3 405.33",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.22 387.91 351.58 398.04 360.04 398.15 361.08 388.06 351.22 387.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.68,402.7l8.14.13a.57.57,0,0,1,.57.52l.7,6.65a1.22,1.22,0,0,1-1.23,1.31c-2.93-.09-7.15-.33-10.84-.39-4.31-.07-3.89.11-8.95,0-3.06-.05-3.54-3.16-2.23-3.42,6-1.18,6.58-1.24,12-4.27A3.76,3.76,0,0,1,351.68,402.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.33,403.37a.19.19,0,0,0,.12-.14.2.2,0,0,0-.09-.19c-.34-.18-3.31-1.74-4.22-1.25a.54.54,0,0,0-.3.46h0a1,1,0,0,0,.31.87c.81.73,3,.47,4.16.25Zm-4-1.3c.56-.19,2.18.46,3.35,1-1.65.25-2.88.16-3.33-.25a.64.64,0,0,1-.2-.58.21.21,0,0,1,.11-.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.33,403.37l0,0a.16.16,0,0,0,.08-.15c0-.09-.17-2.1-1.1-2.9a1.32,1.32,0,0,0-1-.32h0c-.49,0-.63.29-.67.49-.15.84,1.61,2.48,2.5,2.9A.2.2,0,0,0,350.33,403.37Zm-2.11-3a.74.74,0,0,1,.18,0h0a.92.92,0,0,1,.72.23,4.2,4.2,0,0,1,.94,2.32c-.91-.57-2.1-1.85-2-2.36C348.06,400.49,348.07,400.41,348.22,400.36Zm.17-.21h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.79,323.13c11.09-38.08,21.43-64.54,19-83.43l-26.32.31s-13.94,61.74-12.9,84.08c1.08,23.23,2.45,67.37,2.45,67.37l12,.17S370.91,349.08,367.79,323.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.25,307.78c5.88-19.42,11.15-32.92,14.19-44.23C369,269.7,369.35,291,372.25,307.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.32 388.79 349.05 393.94 362.25 394.17 363.04 389.31 348.32 388.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.32 388.79 349.05 393.94 362.25 394.17 363.04 389.31 348.32 388.79",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.19 405.33 402.71 405.24 398.83 387.9 408.43 388.05 410.19 405.33",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.83 387.91 401.08 397.92 409.45 398.03 408.44 388.06 398.83 387.91",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.15,403.71l8.13-.16a.58.58,0,0,1,.6.5l.94,6.62a1.21,1.21,0,0,1-1.17,1.35c-2.93,0-3.86-.19-7.55-.12-4.31.09-2.32.19-7.37.3-3.06.06-3.66-3-2.36-3.34,4.11-1,5.13-2.7,6.94-4.53A2.61,2.61,0,0,1,402.15,403.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.64,404.22a.19.19,0,0,0,.16-.09.2.2,0,0,0,0-.21c-.26-.27-2.61-2.68-3.63-2.5a.59.59,0,0,0-.43.35h0a1,1,0,0,0,0,.92c.53.95,2.65,1.37,3.87,1.53Zm-3.37-2.46c.6,0,1.94,1.11,2.87,2-1.65-.27-2.78-.74-3.09-1.27a.66.66,0,0,1,0-.61.18.18,0,0,1,.16-.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.64,404.22h.05a.15.15,0,0,0,.12-.12c0-.09.49-2-.16-3.1a1.24,1.24,0,0,0-.83-.6h0c-.47-.11-.69.07-.78.25-.4.76.76,2.86,1.48,3.53A.15.15,0,0,0,403.64,404.22Zm-1.08-3.51a.62.62,0,0,1,.18,0h0a1,1,0,0,1,.61.45,4.08,4.08,0,0,1,.18,2.49c-.69-.82-1.42-2.41-1.18-2.86A.21.21,0,0,1,402.56,400.71Zm.22-.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.68,324.33c4.09-38.09,7.47-66.16,1.56-85l-27.42.73s.67,62.94,5.82,85.28c5.35,23.23,16.43,66.17,16.43,66.17l12,.17S409.58,350.27,401.68,324.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.31 388.79 397.1 393.94 410.59 394.17 411.35 389.31 396.31 388.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.31 388.79 397.1 393.94 410.59 394.17 411.35 389.31 396.31 388.79",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.67,167.28a88.86,88.86,0,0,1,25.15.9,10.69,10.69,0,0,1,8.89,9c1.55,10.67,4,31.68-.41,64.46-3.95,1.25-15.58,1.16-24.83.5-1-.08-3.46-2.42-3.46-2.42s-2.22,1.91-3.5,1.76c-6.12-.74-11-1.79-12.13-3-2.5-6-4.07-21.06,2.58-34.57.07-8.09-1.53-17.2-1.67-25.89A10.64,10.64,0,0,1,370.67,167.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.82,153.48c.74,5.55,1.87,12,5.79,15.14a11.73,11.73,0,0,1-10.53,7.55c-5.94.31-5-4.43-4-6.94,2.52-2.83,1.31-6,.67-8.23Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.18,156.19c0-.35-.1-.7-.15-1.05L376.71,161a13.4,13.4,0,0,1,.84,4.74C380.68,163.65,383.56,159.56,383.18,156.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.9,145.41c-.94,7.34-1.11,11.69-5.08,15.19-6,5.28-14.86,1.22-16.14-6.26-1.15-6.74.57-17.61,8-20A10.2,10.2,0,0,1,386.9,145.41Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.15,149.57c0,.6-.39,1.06-.79,1s-.68-.53-.64-1.13.39-1.07.79-1S375.18,149,375.15,149.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.64,149.25c0,.6-.39,1.06-.78,1s-.68-.54-.64-1.14.39-1.06.78-1S367.68,148.65,367.64,149.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.21,149.75h-5.55a.87.87,0,0,0-.87.78,2.11,2.11,0,0,0-1.71,0,.88.88,0,0,0-.87-.77H364a.89.89,0,0,0-.89.89v2.57a.89.89,0,0,0,.89.89h4.24a.89.89,0,0,0,.89-.89v-2.1a1.57,1.57,0,0,1,1.67,0v2.12a.89.89,0,0,0,.89.89h5.55a.89.89,0,0,0,.89-.89v-2.57A.89.89,0,0,0,377.21,149.75Zm-8.63,3.46a.38.38,0,0,1-.37.37H364a.37.37,0,0,1-.37-.37v-2.57a.37.37,0,0,1,.37-.37h4.24a.38.38,0,0,1,.37.37Zm9,0a.36.36,0,0,1-.37.37h-5.55a.36.36,0,0,1-.37-.37v-2.57a.36.36,0,0,1,.37-.37h5.55a.38.38,0,0,1,.37.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.93,150.86a17.86,17.86,0,0,1-2.95,4,3,3,0,0,0,2.35.78Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6,146.28a.34.34,0,0,0,.15-.09.35.35,0,0,0,0-.5,3.52,3.52,0,0,0-3-1.12.35.35,0,0,0-.28.41.37.37,0,0,0,.42.28h0a2.82,2.82,0,0,1,2.39.92A.38.38,0,0,0,376.6,146.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.36,146.19a.36.36,0,0,0,.32-.1,2.78,2.78,0,0,1,2.39-.89.35.35,0,1,0,.12-.69,3.43,3.43,0,0,0-3,1.08.36.36,0,0,0,0,.5A.3.3,0,0,0,365.36,146.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.53,165.87c.18,1.7-1.86,7.73-9,10.31,2.75,0,3.95,3.51,3.95,3.51s9.45-5,8.32-11.11A3.35,3.35,0,0,0,388.53,165.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.34,166.33c.17,1.67-1.76,5.17,2.21,9.85-2.76,0-4.4,2.76-4.4,2.76a11.75,11.75,0,0,1-.78-11.24A5.47,5.47,0,0,1,377.34,166.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.53,165.87c.18,1.7-1.86,7.73-9,10.31,2.75,0,3.95,3.51,3.95,3.51s9.45-5,8.32-11.11A3.35,3.35,0,0,0,388.53,165.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.34,166.33c.17,1.67-1.76,5.17,2.21,9.85-2.76,0-4.4,2.76-4.4,2.76a11.75,11.75,0,0,1-.78-11.24A5.47,5.47,0,0,1,377.34,166.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "358.64 244.35 405.69 245.62 405.69 239.7 359.36 238.46 358.64 244.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.64 244.35 405.69 245.62 405.69 239.7 359.36 238.46 358.64 244.35",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.46,243.41l1.53,24.2,12.47-.79a3,3,0,0,0,2.78-3.15l-1.19-18.8a2.44,2.44,0,0,0-2.59-2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.46,243.41l1.53,24.2,12.47-.79a3,3,0,0,0,2.78-3.15l-1.19-18.8a2.44,2.44,0,0,0-2.59-2.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,243.25h1.48a0,0,0,0,1,0,0V267.5a0,0,0,0,1,0,0h-2a2.29,2.29,0,0,1-2.29-2.29V246A2.78,2.78,0,0,1,395,243.25Z",
    transform: "translate(804.03 485.38) rotate(176.39)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.92,246.34l0-.76a2.44,2.44,0,0,0-2.6-2.28l11.18-.71a2.44,2.44,0,0,1,2.59,2.28l.05.76.11,1.85a2.13,2.13,0,0,1-2,2.26l-6.92.43a2.12,2.12,0,0,1-2.26-2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.74,247.76a.84.84,0,1,0,.78-.89A.83.83,0,0,0,400.74,247.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.88,241.74a.85.85,0,0,0,1.69,0,.85.85,0,0,0-1.69,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.17,
    y: 249.94,
    width: 4.22,
    height: 17.06,
    transform: "translate(-15.5 25.88) rotate(-3.61)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.21,152.13s-2.25.21-1.64-2.94-2.49-6.28-1.61-9.29-8.69-.67-9.38-3-.84,4.25-3.8,3.35c-2.58-.78.78-3.87.78-3.87s-3.95,2.25-3.95,0,4.66-2.15,6.31-2.54c4.7-1.13,14.95-6.66,17.85,7.42,0,0,4.39,3.07-2,12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07,179.78a196.56,196.56,0,0,1,1.71,26.49c-6.33-5.47-11.87-20.37-11.87-20.37V180l4.72-3.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.61 196.95 349 189.73 348.01 193.12 359.36 199.56 361.61 196.95",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.61 196.95 349 189.73 348.01 193.12 359.36 199.56 361.61 196.95",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.85,133.16s9.87-9.24,18.85-1.61c7.48,6.37,1.1,16.29,1.1,16.29l-3.6-4.2-7-6-6.41-3.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.59,132.52c4.34-3.33,17.44,2.89,25.34,15.42l0,.1c-2.23-2.44-14.51-15.39-21.91-13.79C367,134.25,360.92,134.57,363.59,132.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M363.59,132.52c4.34-3.33,17.44,2.89,25.34,15.42l0,.1c-2.23-2.44-14.51-15.39-21.91-13.79C367,134.25,360.92,134.57,363.59,132.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,130.47c3.33-1.9,9.81-4.3,15.84.83,6.46,5.49,2.88,13.57,1.63,15.91l-.61-.27c0-.1,3.52-9.43-1.41-13.6-4-3.41-8.89-1.58-11.43-.19l-.17.09-.17-.1c-.83-.53-2.14-1.31-3.67-2.08l-.55-.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.07,130.47c3.33-1.9,9.81-4.3,15.84.83,6.46,5.49,2.88,13.57,1.63,15.91l-.61-.27c0-.1,3.52-9.43-1.41-13.6-4-3.41-8.89-1.58-11.43-.19l-.17.09-.17-.1c-.83-.53-2.14-1.31-3.67-2.08l-.55-.29Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.13,158.66a6.57,6.57,0,0,1-1.05-.09.19.19,0,0,1-.15-.22.18.18,0,0,1,.21-.15,5,5,0,0,0,4.35-1.21.18.18,0,0,1,.27.25A5.15,5.15,0,0,1,371.13,158.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.6,191.93H383.21l.44,1.55a2.12,2.12,0,0,0,2,1.55h7.95a2.13,2.13,0,0,0,1.87-1.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.07,193.4a.83.83,0,0,0,.83.83.84.84,0,0,0,.84-.83.85.85,0,0,0-.84-.84A.84.84,0,0,0,389.07,193.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.72,191.85H362.94l.35,1.55a1.81,1.81,0,0,0,1.65,1.55h6.4a1.71,1.71,0,0,0,1.51-1.11Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,193.4a.83.83,0,0,0,.83.83.84.84,0,0,0,.84-.83.85.85,0,0,0-.84-.84A.84.84,0,0,0,366.6,193.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.74 150.4 383.94 149.98 383.89 149.31 377.16 149.78 377.74 150.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.91,153.07a6.9,6.9,0,0,1-4.39,3.06c-2.41.51-3.48-1.69-2.69-3.88.71-2,2.82-4.62,5.18-4.14A3.18,3.18,0,0,1,388.91,153.07Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.56,201.9l-.5,1.56a.24.24,0,0,0,.34.29l1.47-.74,8.74-10.28a.52.52,0,0,0-.06-.73l-.51-.44a.52.52,0,0,0-.74.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.56,201.9l-.5,1.56a.24.24,0,0,0,.34.29l1.47-.74,8.74-10.28a.52.52,0,0,0-.06-.73l-.51-.44a.52.52,0,0,0-.74.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,191.46l-9.11,10.71-.61,1.51a.22.22,0,0,1-.05-.22l.5-1.56,8.74-10.28A.52.52,0,0,1,384.83,191.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.33,202.3l-6-3-1.38,7.92s5.77,2,7.34-.87Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.7,201.54v2.86a2.31,2.31,0,0,0,1.93,2.3l3.31.56,1.38-7.92-4.22-.11A2.34,2.34,0,0,0,376.7,201.54Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.51,206.56a67.37,67.37,0,0,0,13.63,6.68,33.92,33.92,0,0,0,3.92,1.11,18,18,0,0,0,4.76.42,9,9,0,0,0,3.38-.88,7.35,7.35,0,0,0,2-1.45c.15-.16.32-.36.44-.5l.29-.39c.19-.26.34-.53.5-.8a11.82,11.82,0,0,0,1.37-5.86,22,22,0,0,0-.55-4.59,38.41,38.41,0,0,0-1.1-4A67.09,67.09,0,0,0,412.2,189c-1.1-2.3-2.26-4.55-3.52-6.73s-2.51-4.29-4-6.47a5.14,5.14,0,0,0-8.61,5.61l.05.09c1.17,1.87,2.43,3.92,3.57,5.92s2.27,4,3.29,6.08a62.61,62.61,0,0,1,2.75,6.09,21.37,21.37,0,0,1,1.48,5.52,5.3,5.3,0,0,1,0,.77,12.74,12.74,0,0,1-1.84,0c-1-.1-2.08-.23-3.17-.44-4.38-.83-9-2.16-13.54-3.49l-.09,0a2.56,2.56,0,0,0-2.08,4.63Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.65,169.35C410.1,172.64,416,194.54,416,194.54L404.66,199a33.81,33.81,0,0,1-9.14-11C394.37,185.77,391.32,166.72,399.65,169.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.97 191.93 402.11 197.41 404.15 200.31 416.86 195.28 415.97 191.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.97 191.93 402.11 197.41 404.15 200.31 416.86 195.28 415.97 191.93",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.89 194.64 371.35 194.64 385.72 219.68 385.17 220.24 364.71 220.24 350.33 195.19 350.89 194.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.89 194.64 371.35 194.64 385.72 219.68 385.17 220.24 364.71 220.24 350.33 195.19 350.89 194.64",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.71 220.24 385.17 220.24 370.79 195.19 350.33 195.19 364.71 220.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.71 220.24 385.17 220.24 370.79 195.19 350.33 195.19 364.71 220.24",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.13 194.27 363.92 194.27 365.57 197.15 365.34 197.38 357.55 197.38 355.9 194.5 356.13 194.27",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.13 194.27 363.92 194.27 365.57 197.15 365.34 197.38 357.55 197.38 355.9 194.5 356.13 194.27",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.55 197.38 355.9 194.5 363.69 194.5 365.34 197.38 357.55 197.38",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.55 197.38 355.9 194.5 363.69 194.5 365.34 197.38 357.55 197.38",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.76,210.65a15,15,0,0,1,0-4.13c.05-.36.12-.69.18-1h9.59a19.75,19.75,0,0,0-.66,2.42,7.14,7.14,0,0,0-.17,1.57,1.77,1.77,0,0,1,0,.19,1.23,1.23,0,0,0,.23.11,15,15,0,0,0,2.21.75c1.62.45,3.47.83,5.22,1.27l.19,0a2.5,2.5,0,0,1,.15,4.81,24.58,24.58,0,0,1-6.2,1.14,18.44,18.44,0,0,1-3.45-.1,13.45,13.45,0,0,1-2-.46,7.88,7.88,0,0,1-2.48-1.27,7.07,7.07,0,0,1-.71-.64,8.13,8.13,0,0,1-.66-.8,9.27,9.27,0,0,1-.73-1.34A9.6,9.6,0,0,1,345.76,210.65Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,216.66l7.11-1-4.1-6.58s-6,.88-5.6,4.59Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27,211.68l-1.28-3a2,2,0,0,0-2.73-1l-2.91,1.39,4.1,6.58,2.15-1.55A2,2,0,0,0,372.27,211.68Z",
    style: {
      fill: "#b55b52"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--House--inject-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "104.59 238.3 112.54 238.3 112.54 241.44 111.24 241.44 111.24 255.53 105.89 255.53 105.89 241.44 104.59 241.44 104.59 238.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "104.59 238.3 112.54 238.3 112.54 241.44 111.24 241.44 111.24 255.53 105.89 255.53 105.89 241.44 104.59 241.44 104.59 238.3"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "151.59 228.26 179.82 271.69 179.82 310.66 112.98 310.66 112.98 271.69 151.59 228.26",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.59 228.26 179.82 271.69 179.82 310.66 112.98 310.66 112.98 271.69 151.59 228.26",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.59 230.03 124.89 223.44 151.59 223.44 183.05 271.69 156.34 271.69 120.59 271.69 120.59 230.03",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.59 230.03 124.89 223.44 151.59 223.44 183.05 271.69 156.34 271.69 120.59 271.69 120.59 230.03",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.34 271.69 124.89 223.44 93.43 271.69 156.34 271.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.89 228.26 153.11 271.69 153.11 310.66 96.66 310.66 96.66 271.69 124.89 228.26",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.89 228.26 153.11 271.69 153.11 310.66 96.66 310.66 96.66 271.69 124.89 228.26",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.84,
    y: 253.26,
    width: 5.71,
    height: 15.13,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.85,
    y: 253.26,
    width: 5.71,
    height: 15.13,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.56,
    y: 252.54,
    width: 14.27,
    height: 16.56,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.56,
    y: 252.54,
    width: 14.27,
    height: 16.56,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.34,
    y: 254.33,
    width: 10.71,
    height: 12.99,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.07,
    y: 282.81,
    width: 17.26,
    height: 27.86,
    transform: "translate(249.4 593.47) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.07,
    y: 282.81,
    width: 17.26,
    height: 27.86,
    transform: "translate(249.4 593.47) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.14 276.97 132.26 276.97 135.94 283.79 113.46 283.79 117.14 276.97",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.03,
    y: 287.54,
    width: 5.29,
    height: 23.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.08,
    y: 287.54,
    width: 5.29,
    height: 23.13,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.64,
    y: 338.81,
    width: 80.41,
    height: 68.15,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.64,
    y: 338.81,
    width: 80.41,
    height: 68.15,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.12,
    y: 338.81,
    width: 39.71,
    height: 68.15,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.12,
    y: 338.81,
    width: 39.71,
    height: 68.15,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.82,
    y: 345.66,
    width: 15.82,
    height: 18.35,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.82,
    y: 345.66,
    width: 15.82,
    height: 18.35,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.8,
    y: 347.64,
    width: 11.86,
    height: 14.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.56,
    y: 346.45,
    width: 6.33,
    height: 16.77,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.71,
    y: 346.45,
    width: 6.33,
    height: 16.77,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.89,
    y: 345.66,
    width: 15.82,
    height: 18.35,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.89,
    y: 345.66,
    width: 15.82,
    height: 18.35,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.87,
    y: 347.64,
    width: 11.86,
    height: 14.39,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.23,
    y: 376.64,
    width: 18.78,
    height: 30.31,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.23,
    y: 376.64,
    width: 18.78,
    height: 30.31,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.85 370.29 108.39 370.29 104.39 377.71 128.85 377.71 124.85 370.29",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.51,
    y: 381.79,
    width: 5.75,
    height: 25.16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.98,
    y: 381.79,
    width: 5.75,
    height: 25.16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.01 339.39 162.3 310.23 95.4 310.23 79.69 339.39 178.01 339.39",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.01 339.39 162.3 310.23 95.4 310.23 79.69 339.39 178.01 339.39",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.79 339.39 181.08 310.23 154.88 310.23 139.17 339.39 196.79 339.39",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.79 339.39 181.08 310.23 154.88 310.23 139.17 339.39 196.79 339.39",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.39 334.4 110.39 310.23 141.31 310.23 128.29 334.4 110.39 334.4",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.39 334.4 110.39 310.23 141.31 310.23 128.29 334.4 110.39 334.4",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.48,
    y: 315.62,
    width: 18.78,
    height: 18.78,
    transform: "translate(237.74 650.02) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.48,
    y: 315.62,
    width: 18.78,
    height: 18.78,
    transform: "translate(237.74 650.02) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.91,329.88h7.92a1.3,1.3,0,0,1,1.3,1.3v.95a0,0,0,0,1,0,0H113.61a0,0,0,0,1,0,0v-.95A1.3,1.3,0,0,1,114.91,329.88Z",
    transform: "translate(237.74 662.01) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.55,322.18a3.33,3.33,0,1,1,6.65,0v7.17h-6.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.19 316.69 125.68 310.23 141.31 310.23 137.83 316.69 122.19 316.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.19 316.69 125.68 310.23 141.31 310.23 137.83 316.69 122.19 316.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.61 310.23 131.1 316.69 106.64 316.69 110.13 310.23 127.61 310.23",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.49,
    y: 345.66,
    width: 15.82,
    height: 18.35,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.49,
    y: 345.66,
    width: 15.82,
    height: 18.35,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.46,
    y: 347.64,
    width: 11.86,
    height: 14.39,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191,406.28H338.13a4.47,4.47,0,0,0,4.51-4.95l-18.47-211a5.5,5.5,0,0,0-5.37-4.95H171.64a4.47,4.47,0,0,0-4.51,4.95l18.47,211A5.5,5.5,0,0,0,191,406.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.09,406.28H340.25a4.46,4.46,0,0,0,4.51-4.95l-18.46-211a5.51,5.51,0,0,0-5.38-4.95H173.77a4.46,4.46,0,0,0-4.51,4.95l18.46,211A5.5,5.5,0,0,0,193.09,406.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.09,406.28H340.25a4.46,4.46,0,0,0,4.51-4.95l-18.46-211a5.51,5.51,0,0,0-5.38-4.95H173.77a4.46,4.46,0,0,0-4.51,4.95l18.46,211A5.5,5.5,0,0,0,193.09,406.28Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.61 197.57 330.26 398.62 197.62 398.62 179.97 197.57 312.61 197.57",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.42,197.58l5.09,64.83q2,25.21,6,50.2l13,81.46H204.84l-13-81.66q-4-24.95-5.95-50.14l-5.08-64.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.39,223.35h49.73a2.59,2.59,0,0,0,2.62-3l-.39-3.23a3.47,3.47,0,0,0-3.35-3H224.26a2.58,2.58,0,0,0-2.61,3l.39,3.23A3.47,3.47,0,0,0,225.39,223.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.39,290.19H311.16a2.58,2.58,0,0,0,2.61-3l-.39-3.23a3.47,3.47,0,0,0-3.35-3H203.26a2.59,2.59,0,0,0-2.62,3l.4,3.23A3.47,3.47,0,0,0,204.39,290.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.39,290.19H311.16a2.58,2.58,0,0,0,2.61-3l-.39-3.23a3.47,3.47,0,0,0-3.35-3H203.26a2.59,2.59,0,0,0-2.62,3l.4,3.23A3.47,3.47,0,0,0,204.39,290.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.19,237.11H220.46c-1,0-1.16-1.59-.14-1.59h49.73c1,0,1.17,1.59.14,1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,241.53h71.52c1,0,1.17,1.6.14,1.6H199.4c-1,0-1.16-1.6-.13-1.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.16,243.39h24.27a2.59,2.59,0,0,0,2.62-3l-.4-3.23a3.46,3.46,0,0,0-3.35-3H280a2.58,2.58,0,0,0-2.62,3l.4,3.23A3.47,3.47,0,0,0,281.16,243.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.16,243.39h24.27a2.59,2.59,0,0,0,2.62-3l-.4-3.23a3.46,3.46,0,0,0-3.35-3H280a2.58,2.58,0,0,0-2.62,3l.4,3.23A3.47,3.47,0,0,0,281.16,243.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.84,261.9h12.85a2.59,2.59,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.34-3H293.9a2.58,2.58,0,0,0-2.62,3l.21,1.69A3.47,3.47,0,0,0,294.84,261.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.54,261.9h29.83a2.59,2.59,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.34-3H254.6a2.57,2.57,0,0,0-2.61,3l.2,1.69A3.48,3.48,0,0,0,255.54,261.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.67,261.9h22.41a2.6,2.6,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.35-3h-22.4a2.58,2.58,0,0,0-2.62,3l.2,1.69A3.49,3.49,0,0,0,223.67,261.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.41,261.9h11.8a2.59,2.59,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.35-3H201.48a2.58,2.58,0,0,0-2.62,3l.21,1.69A3.47,3.47,0,0,0,202.41,261.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.66,273.09h22.4a2.58,2.58,0,0,0,2.62-3l-.21-1.69a3.47,3.47,0,0,0-3.34-3H285.72a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,286.66,273.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,273.09h26.64a2.58,2.58,0,0,0,2.62-3l-.2-1.69a3.49,3.49,0,0,0-3.35-3H249.61a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,250.55,273.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23,273.09h12.85a2.58,2.58,0,0,0,2.62-3l-.21-1.69a3.47,3.47,0,0,0-3.35-3H227.29a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,228.23,273.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,273.09h15a2.58,2.58,0,0,0,2.62-3l-.21-1.69a3.47,3.47,0,0,0-3.35-3h-15a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,203.78,273.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.84,261.9h12.85a2.59,2.59,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.34-3H293.9a2.58,2.58,0,0,0-2.62,3l.21,1.69A3.47,3.47,0,0,0,294.84,261.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.54,261.9h29.83a2.59,2.59,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.34-3H254.6a2.57,2.57,0,0,0-2.61,3l.2,1.69A3.48,3.48,0,0,0,255.54,261.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.67,261.9h22.41a2.6,2.6,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.35-3h-22.4a2.58,2.58,0,0,0-2.62,3l.2,1.69A3.49,3.49,0,0,0,223.67,261.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.41,261.9h11.8a2.59,2.59,0,0,0,2.62-3l-.21-1.69a3.46,3.46,0,0,0-3.35-3H201.48a2.58,2.58,0,0,0-2.62,3l.21,1.69A3.47,3.47,0,0,0,202.41,261.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.66,273.09h22.4a2.58,2.58,0,0,0,2.62-3l-.21-1.69a3.47,3.47,0,0,0-3.34-3H285.72a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,286.66,273.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.55,273.09h26.64a2.58,2.58,0,0,0,2.62-3l-.2-1.69a3.49,3.49,0,0,0-3.35-3H249.61a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,250.55,273.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.23,273.09h12.85a2.58,2.58,0,0,0,2.62-3l-.21-1.69a3.47,3.47,0,0,0-3.35-3H227.29a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,228.23,273.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,273.09h15a2.58,2.58,0,0,0,2.62-3l-.21-1.69a3.47,3.47,0,0,0-3.35-3h-15a2.59,2.59,0,0,0-2.62,3l.21,1.69A3.46,3.46,0,0,0,203.78,273.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,385.93H211.8c-1,0-1.16-1.59-.14-1.59h34.55c1,0,1.17,1.59.14,1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.83,385.93H291.28c-1,0-1.16-1.59-.14-1.59h34.55c1,0,1.17,1.59.14,1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.84,337h-44.1c-1,0-1.17-1.59-.14-1.59h44.1c1,0,1.16,1.59.14,1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.35,341.49h44.1c1,0,1.16,1.59.14,1.59h-44.1c-1,0-1.17-1.59-.14-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.1,347.61h44.1c1,0,1.16,1.59.14,1.59h-44.1c-1,0-1.17-1.59-.14-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85,353.73H322c1,0,1.16,1.59.13,1.59H278c-1,0-1.17-1.59-.14-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.6,359.85h44.1c1,0,1.16,1.6.13,1.6H278.74c-1,0-1.17-1.6-.14-1.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.9,337H219.35c-1,0-1.16-1.59-.14-1.59h34.55c1,0,1.17,1.59.14,1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,341.49h34.55c1,0,1.17,1.59.14,1.59H220.1c-1,0-1.17-1.59-.14-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.71,347.61h34.55c1,0,1.16,1.59.14,1.59H220.85c-1,0-1.17-1.59-.14-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.46,353.73H256c1,0,1.16,1.59.14,1.59H221.6c-1,0-1.17-1.59-.14-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.21,359.85h34.55c1,0,1.16,1.6.14,1.6H222.35c-1,0-1.17-1.6-.14-1.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.87,305.44h0l.91,7.43h0l.91,7.43h0l.91,7.42H319.13l-1-8.22h0l-.91-7.43h0l-.91-7.42h0l-.91-7.43H201.86Zm20.26-4.11.4,3.32h-20l-.81-6.64h20Zm1.7,7.43-.4-3.32h34.81l.41,3.32.4,3.31H225.24ZM260,305.44h34.81l.41,3.32.4,3.31H260.85l-.41-3.31Zm36.53,14.06H261.76l-.41-3.32-.4-3.31h34.81l.41,3.31Zm-35.61,0H226.15l-.41-3.32-.41-3.31h34.82l.4,3.31Zm-2.22-18.17.4,3.32H224.33l-.41-3.32-.4-3.32h34.81Zm35.61,0,.4,3.32H259.94l-.41-3.32-.4-3.32h34.81Zm21.16,3.32h-20l-.41-3.32-.4-3.32h20Zm.91,7.42h-20l-.41-3.31-.4-3.32h20Zm.91,7.43h-20l-.41-3.32-.4-3.31h20Zm-19.46,4.11-.4-3.31h20l.81,6.63h-20Zm-35.61,0-.41-3.31h34.82l.4,3.31.41,3.32H262.67Zm-35.61,0-.41-3.31h34.82l.4,3.31.41,3.32H227.06Zm-21.16-3.31h20l.4,3.31.41,3.32h-20Zm-.91-7.43h20l.4,3.31.41,3.32h-20Zm-.91-7.43h20l.4,3.32.41,3.31h-20Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.87,305.44h0l.91,7.43h0l.91,7.43h0l.91,7.42H319.13l-1-8.22h0l-.91-7.43h0l-.91-7.42h0l-.91-7.43H201.86Zm20.26-4.11.4,3.32h-20l-.81-6.64h20Zm1.7,7.43-.4-3.32h34.81l.41,3.32.4,3.31H225.24ZM260,305.44h34.81l.41,3.32.4,3.31H260.85l-.41-3.31Zm36.53,14.06H261.76l-.41-3.32-.4-3.31h34.81l.41,3.31Zm-35.61,0H226.15l-.41-3.32-.41-3.31h34.82l.4,3.31Zm-2.22-18.17.4,3.32H224.33l-.41-3.32-.4-3.32h34.81Zm35.61,0,.4,3.32H259.94l-.41-3.32-.4-3.32h34.81Zm21.16,3.32h-20l-.41-3.32-.4-3.32h20Zm.91,7.42h-20l-.41-3.31-.4-3.32h20Zm.91,7.43h-20l-.41-3.32-.4-3.31h20Zm-19.46,4.11-.4-3.31h20l.81,6.63h-20Zm-35.61,0-.41-3.31h34.82l.4,3.31.41,3.32H262.67Zm-35.61,0-.41-3.31h34.82l.4,3.31.41,3.32H227.06Zm-21.16-3.31h20l.4,3.31.41,3.32h-20Zm-.91-7.43h20l.4,3.31.41,3.32h-20Zm-.91-7.43h20l.4,3.32.41,3.31h-20Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.62,342h3.29a1,1,0,0,0,1-1.11l-.4-3.29a1.29,1.29,0,0,0-1.24-1.11h-3.3a1,1,0,0,0-1,1.11l.4,3.29A1.3,1.3,0,0,0,209.62,342Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,348h3.3a1,1,0,0,0,1-1.11l-.4-3.29a1.3,1.3,0,0,0-1.25-1.11h-3.29a1,1,0,0,0-1,1.11l.4,3.29A1.29,1.29,0,0,0,210.35,348Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.09,354h3.29a1,1,0,0,0,1-1.1l-.41-3.3a1.28,1.28,0,0,0-1.24-1.1h-3.29a1,1,0,0,0-1,1.1l.41,3.3A1.28,1.28,0,0,0,211.09,354Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.83,360h3.29a1,1,0,0,0,1-1.11l-.4-3.29a1.29,1.29,0,0,0-1.25-1.11h-3.29a1,1,0,0,0-1,1.11l.4,3.29A1.3,1.3,0,0,0,211.83,360Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.35,348h3.3a1,1,0,0,0,1-1.11l-.4-3.29a1.3,1.3,0,0,0-1.25-1.11h-3.29a1,1,0,0,0-1,1.11l.4,3.29A1.29,1.29,0,0,0,210.35,348Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.83,360h3.29a1,1,0,0,0,1-1.11l-.4-3.29a1.29,1.29,0,0,0-1.25-1.11h-3.29a1,1,0,0,0-1,1.11l.4,3.29A1.3,1.3,0,0,0,211.83,360Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.28,181.76h13l-2-4.89c-.65-1.54.72-3,2.76-3H252.7c2,0,3.67,1.49,3.29,3l-1.2,4.89h13a7.9,7.9,0,0,1,7.73,7.1l1,11.41a3.7,3.7,0,0,1-3.74,4.1H225.25a4.56,4.56,0,0,1-4.45-4.1l-1-11.41A6.4,6.4,0,0,1,226.28,181.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.79 181.76 239.26 181.76 238.05 178.88 255.5 178.88 254.79 181.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.25,197.53a2.46,2.46,0,0,0,2.4,2.21,2,2,0,0,0,2-2.21,2.46,2.46,0,0,0-2.4-2.21A2,2,0,0,0,265.25,197.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,197.53a2.47,2.47,0,0,0,2.41,2.21,2,2,0,0,0,2-2.21,2.45,2.45,0,0,0-2.4-2.21A2,2,0,0,0,227.14,197.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.24,377.85l-58.8,11.5a4.74,4.74,0,0,1-5.78-4.11l-1-8.94a5.78,5.78,0,0,1,4.64-6.14l58.8-11.5a4.75,4.75,0,0,1,5.79,4.11l1,8.94A5.78,5.78,0,0,1,311.24,377.85Zm-60.77-6.2a4.1,4.1,0,0,0-3.29,4.35l1,8.94a3.36,3.36,0,0,0,4.1,2.91l58.79-11.49a4.1,4.1,0,0,0,3.29-4.36l-1-8.94a3.35,3.35,0,0,0-4.09-2.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.8,380.13l-3,.58-.42,1.46-1.51.3,2.15-6.84,1.46-.29,3.56,5.72-1.56.31Zm-.59-1-1.28-2.21-.75,2.61Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,374.1a1.9,1.9,0,0,1,1.53,1.75,2.27,2.27,0,0,1-.21,1.27,2.33,2.33,0,0,1-.87,1,4,4,0,0,1-1.45.56l-1.28.25.19,1.74-1.48.28-.7-6.28,2.77-.54A3.61,3.61,0,0,1,265.3,374.1Zm-.23,2.91a1.05,1.05,0,0,0,.26-.87.89.89,0,0,0-.44-.74,1.5,1.5,0,0,0-1-.09l-1.21.24.25,2.18,1.2-.24A1.65,1.65,0,0,0,265.07,377Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.89,372.81a2,2,0,0,1,1.05.61,1.92,1.92,0,0,1,.48,1.14,2.26,2.26,0,0,1-.21,1.27,2.33,2.33,0,0,1-.87,1,3.87,3.87,0,0,1-1.44.56l-1.29.25.19,1.74-1.48.29-.7-6.29,2.77-.54A3.61,3.61,0,0,1,271.89,372.81Zm-.23,2.91a1.05,1.05,0,0,0,.26-.87.89.89,0,0,0-.44-.74,1.56,1.56,0,0,0-1-.09l-1.21.24.25,2.18,1.2-.24A1.62,1.62,0,0,0,271.66,375.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,377.56l-1.43-1.51-.08,0-1.28.25.19,1.75-1.48.29-.7-6.28,2.77-.54a3.35,3.35,0,0,1,1.51,0,2,2,0,0,1,1.05.6,2,2,0,0,1,.47,1.14,2.29,2.29,0,0,1-.21,1.28,2.44,2.44,0,0,1-.88,1l1.65,1.74Zm-.92-4.74a1.51,1.51,0,0,0-1-.08l-1.21.23.25,2.19,1.2-.23a1.69,1.69,0,0,0,1-.49,1,1,0,0,0,.26-.87A.89.89,0,0,0,278.07,372.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.89,376.48a2.85,2.85,0,0,1-2-2.5,3.27,3.27,0,0,1,.27-1.75,3.62,3.62,0,0,1,1.12-1.41,4.15,4.15,0,0,1,1.75-.77,3.73,3.73,0,0,1,1.83.07,2.93,2.93,0,0,1,1.38.92,2.87,2.87,0,0,1,.64,1.58,3.27,3.27,0,0,1-.27,1.75,3.72,3.72,0,0,1-1.12,1.41,4.17,4.17,0,0,1-1.74.77A3.77,3.77,0,0,1,282.89,376.48Zm2.7-1.63a2.13,2.13,0,0,0,.63-.85,2.21,2.21,0,0,0,.15-1.09,2,2,0,0,0-.38-1,1.67,1.67,0,0,0-.79-.57,2,2,0,0,0-1.06-.06,2.26,2.26,0,0,0-1,.46,2.06,2.06,0,0,0-.64.85,2.21,2.21,0,0,0-.14,1.09,2,2,0,0,0,.37,1,1.69,1.69,0,0,0,.8.57,1.94,1.94,0,0,0,1,.06A2.24,2.24,0,0,0,285.59,374.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.56,368.1l-2.06,6.82-1.46.29-3.46-5.75,1.6-.31,2.44,4.11,1.47-4.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.61,372.14l.13,1.17-4.95,1-.7-6.29,4.83-.94.13,1.17-3.36.65.15,1.37,3-.58.13,1.13-3,.58.16,1.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.22,366.8l2.9-.57a4,4,0,0,1,1.88,0,2.69,2.69,0,0,1,1.37.86,2.88,2.88,0,0,1,.62,1.56,3.18,3.18,0,0,1-.26,1.74,3.27,3.27,0,0,1-1.12,1.34,4.31,4.31,0,0,1-1.79.75l-2.9.57Zm3.39,4.53a2.38,2.38,0,0,0,1.47-.82,2.05,2.05,0,0,0,.42-1.54,1.72,1.72,0,0,0-.73-1.31,2.08,2.08,0,0,0-1.59-.22l-1.35.26.43,3.9Z",
    style: {
      fill: "#407BFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkpermit);
export default __webpack_public_path__ + "static/media/workpermit.49b199e2783efd60851fddf25101105c.svg";
export { ForwardRef as ReactComponent };